import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs';
import { ColumnTypesStateService } from './column-types-state.service';
import { ColumnDataType } from './column-data-type.model';

@UntilDestroy()
@Directive({
  selector: '[y42ColumnTypeCssStyles]',
})
export class ColumnTypeCssStylesDirective implements OnInit, OnDestroy {
  constructor(private readonly host: ElementRef, private readonly columnTypesStateService: ColumnTypesStateService) {}

  style: HTMLStyleElement = document.createElement('style');

  ngOnInit() {
    const aliases: Record<string, string[]> = {
      numeric: ['number'],
    };
    const buildCssRule = (columnType: string, type: ColumnDataType) => `.monaco-token-type--${columnType}:before,
.ag-column-select-column.grid-column-type--${columnType} .ag-column-select-column-label:before {
  background-color: ${type.color};
  background-image: url('${type.icon}');
}\n.token-type--${columnType} {
  color: ${type.color};
}`;
    this.columnTypesStateService
      .select((state) => state.entityState)
      .pipe(
        tap((types) => {
          let cssRules = '';
          (types || []).forEach((type) => {
            if (!type.columnType) {
              return;
            }
            const columnType = type.columnType.toLowerCase();
            cssRules += buildCssRule(columnType, type);
            (aliases[columnType] || []).forEach((alias) => (cssRules += buildCssRule(alias, type)));
          });
          this.style.innerHTML = cssRules;
        }),
        untilDestroyed(this),
      )
      .subscribe();
    this.host.nativeElement.appendChild(this.style);
  }

  ngOnDestroy() {
    this.style.remove();
  }
}
